// import { useEffect } from 'react';
import { useAuth } from '../../../context/Auth';
// import { useTutorialContext } from '../../../context/Tutorial';
// import { useUserStrategies } from '../../../context/UserStrategies';

import { WorkspacesProvider } from '../../../context/Workspaces';
import { Workspace } from '../../Widget';

export const Compare = () => {
  const { user } = useAuth();
  // const { strategies } = useUserStrategies();
  // const { handleTooltipIconVisibility, CompareTutorial } = useTutorialContext();

  // useEffect(() => {
  //   strategies.length > 1 && handleTooltipIconVisibility('COMPARE');
  // }, [strategies.length]);

  return (
    <>
      {/* <CompareTutorial /> */}
      <WorkspacesProvider workspaceId={user!.profile!.compareWorkspaceId}>
        <Workspace
          category="COMPARE"
          workspaceId={user!.profile!.compareWorkspaceId}
          fixed={true}
          allowAddWidget={false}
        />
      </WorkspacesProvider>
    </>
  );
};
